const noticeMge = r => require.ensure([], () => r(require('@/page/notice/noticeMge')), 'noticeMge');
const notice = r => require.ensure([], () => r(require('@/page/notice/notice/notice')), 'notice');
const noticeMore = r => require.ensure([], () => r(require('@/page/notice/noticeMore/noticeMore')), 'noticeMore');
const ReleaseNotice = r => require.ensure([], () => r(require('@/page/notice/ReleaseNewsOrNotice/ReleaseNewsOrNotice')), 'ReleaseNewsOrNotice');
const noticeManage = r => require.ensure([], () => r(require('@/page/notice/noticeManage/noticeManage')), 'noticeManage');
const noticeDetails = r => require.ensure([], () => r(require('@/page/notice/noticeDetails/noticeDetails')), 'noticeDetails');
const noticeDetailsforReciver = r => require.ensure([], () => r(require('@/page/notice/noticeDetailsforReciver/noticeDetailsforReciver')), 'noticeDetailsforReciver');
const sendNotice = r => require.ensure([], () => r(require('@/page/notice/sendNotice/sendNotice')), 'sendNotice');
const replyNotice = r => require.ensure([], () => r(require('@/page/notice/replyNotice/replyNotice')), 'replyNotice');

const noticeRouter = {
  path: '',
  component: noticeMge,
  meta: {
    icon: 'organMge',
    right: [],
    isShowMenu: true,
    keepAlive:true
  },
  name: '通知公告',
  redirect: '/noticeMge',
  children: [{
      path: '/noticeMore',
      component: noticeMore,
      name: '更多公告',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      },
    },
    {
      path: '/notice',
      component: notice,
      name: '公告详细',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      },
    }, {
      path: '/ReleaseNotice',
      component: ReleaseNotice,
      name: '发布公告',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      },
    }, {
      path: '/noticeManage',
      component: noticeManage,
      name: '通知管理',
      meta: {
        right: [],
        isShowMenu: true,
        keepAlive:true
      },
    },{
      path: '/sendNotice',
      component: sendNotice,
      name: '发送通知',
      meta: {
        right: [],
        isShowMenu: true,
        keepAlive:false
      },
    },{
      path: '/replyNotice',
      component: replyNotice,
      name: '回复通知',
      meta: {
        right: [],
        isShowMenu: true,
        keepAlive:false
      },
    },
    
    {
      path: '/noticeDetails',
      component: noticeDetails,
      name: '通知详情',
      meta: {
        right: [],
        isShowMenu: true,
        // keepAlive:true
      },
    }, {
      path: '/noticeDetailsforReciver',
      component: noticeDetailsforReciver,
      name: '通知详情',
      meta: {
        right: [],
        isShowMenu: true,
        keepAlive:true
      },
    }
  ]
};

export default noticeRouter;